import Http from '@/network/http'
import UrlBuilder from '@/utils/urlBuilder';

const MID_URL = 'notifications';

export default {
    search: (conditions = null, sorting = null, pagination = null) => {
        let urlBuilder = new UrlBuilder(conditions, sorting, pagination, "v1/" + MID_URL);
        let url = urlBuilder.getUrl();

        return Http.get(url, {
            id: MID_URL,
        })
    },
    store: (data) => {
        return Http.post("v1/" + MID_URL, {
            ...data
        }, {
            id: MID_URL,
        })
    },
    update: (id, data) => {
        return Http.patch("v1/" + MID_URL + "/" + id, {
            ...data
        }, {
            id: MID_URL,
        })
    },
    remove: (id) => {
        return Http.delete("v1/" + MID_URL + "/" + id, {
            id: MID_URL,
        })
    },
}